/** @format */

import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Table, message, Modal, notification, Spin } from "antd";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { path, sessionVar } from "../../../utils/common/constant";
import { Button, Popconfirm } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
// import { replaceNewlinesWithBreaks } from "../../../utils/Constant";
import { getblogs, deleteblogbyid, getblogbyid } from "../../../services/blog";
import Detail from "../../../components/Tiptap/Detail";
import { Tiptap } from "../../../components/Tiptap/Editor";
import { getSessionVar } from "../../../utils/common/hashData";
import parse from "html-react-parser";
const ManageBlogs = () => {
  const navigate = useNavigate();

  const user = getSessionVar(sessionVar.user);
  const pagesize = 5;
  const [totalPages, settotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    if (!user) {
      navigate("../" + path.common.ADMIN);
    }
  }, []);
  const [blogsData, setBlogsData] = useState([]);
  const [isloadingdata, setIsloadingData] = useState(false);

  const [datadetail, setDatadetail] = useState({
    title: "",
    content: "",
    thumbnail: "",
    creator: "",
    creator_avatar: "",
    category: "",
  });

  const handleEditBlog = (e) => {
    navigate("../" + path.private.EDITBLOG, { state: e });
  };

  const getblogbyID = async (e) => {
    await getblogbyid(e)
      .then((res) => {
        setDatadetail(res.data.data);
        setIsModalOpen(true);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  const handledeleteBlog = async (id) => {
    await deleteblogbyid(id)
      .then((res) => {
        if (res.status === 200) {
          notification.success({
            message: "Delete successfully !!!",
            duration: 2,
            placement: "topRight",
          });
          navigate("../" + path.private.MANAGEBLOG);
          getAllBlogs();
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          notification.info({
            message: "Your login session has expired  !!!",
            duration: 3,
            placement: "topRight",
          });
          navigate("../" + path.common.LOGIN);
        } else {
          console.log(err);
        }
      });
  };
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (_, title) => (
        <div className="pv:max-md:w-[100px] w-[200px]">
          <p className=" line-clamp-3  text-primary pv:max-ph:text-[12px] text-[1rem]">
            {title.title}
          </p>
        </div>
      ),
    },

    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, thumbnail) => (
        <div className="flex items-center pv:max-ph:w-[100px] w-[300px] justify-center">
          <img
            alt="thumbnail"
            className="w-full h-[150px] pv:max-sm:h-[100px]  object-cover"
            src={thumbnail.thumbnail}
          ></img>
        </div>
      ),
    },
    {
      title: "Creator",
      dataIndex: "creator",
      key: "creator",
      render: (_, creator) => (
        <p className=" line-clamp-3 text-primary text-[1rem]">
          {creator.creator}
        </p>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (_, category) => (
        <p className=" line-clamp-3 text-primary text-[1rem]">
          {category.category}
        </p>
      ),
    },

    {
      title: "Action",
      key: "action",

      render: (_, record) => (
        <div className="flex  flex-col gap-4 items-center justify-center gap-x-2">
          <Button
            className=" w-[100px] h-fit"
            type="primary"
            onClick={() => {
              getblogbyID(record.id);
            }}
          >
            <p className="">View</p>
          </Button>
          <Button
            className="w-[100px] h-fit"
            onClick={() => {
              // console.log(record)
              handleEditBlog(record);
            }}
          >
            <p className="">Edit</p>
          </Button>

          <Popconfirm
            placement="rightTop"
            title="Confirm Deletion"
            description="Are you sure you want to delete this event?"
            okText="Delete"
            cancelText="Cancel"
            onConfirm={() => {
              handledeleteBlog(record?.id);
              getAllBlogs();
            }}
            icon={
              <QuestionCircleOutlined
                style={{
                  color: "red",
                }}
              />
            }
          >
            <Button danger className="w-[100px] h-fit">
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const getAllBlogs = async () => {
    setIsloadingData(true);
    try {
      const res = await getblogs(currentPage, pagesize);
      const validBlogs = res.data.filter(
        (item) => item.content && item.title && item.thumbnail
      ); // Lọc các mục hợp lệ
      setBlogsData(validBlogs);
      settotalPages(validBlogs.length);
      setIsloadingData(false); // Tắt trạng thái loading
    } catch (err) {
      console.error(err.message);
      setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, [currentPage]);
  console.log(totalPages, "check data");
  return (
    <div className="container  mx-auto px-4">
      <div className="w-full pvmax:max-ph:w-[280px]  mx-auto h-auto  bg-white shadow-xl rounded-lg p-4 sm:p-6">
        <div className="flex flex-wrap items-center justify-between p-2">
          <p className="text-2xl font-bold text-gray-800">Manage Blogs</p>
          <Button
            className="flex items-center gap-x-2 px-4 py-2"
            type="primary"
            onClick={() => navigate("../" + path.private.CREATEBLOG)}
          >
            <Icon icon="mdi:package-variant-add" width={24} height={24} />
            <span className="text-sm sm:text-base">Create Blog</span>
          </Button>
        </div>

        {/* Bảng */}
        <div className="overflow-x-auto">
          {isloadingdata ? (
            <div className="flex justify-center py-6">
              <Spin size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={blogsData}
              loading={isloadingdata}
              pagination={{
                pageSize: pagesize,
                total: totalPages,
                position: ["bottomCenter"],
                current: currentPage,

                onChange: (e) => {
                  setCurrentPage(e);
                },
              }}
              className="w-full overflow-x-auto text-sm sm:text-base"
            />
          )}
        </div>
      </div>

      {/* Modal */}
      <Modal
        title="Detail News"
        open={isModalOpen}
        onOk={handleOk}
        width={isModalOpen ? "90%" : "70%"}
        centered
        onCancel={handleCancel}
        footer={null}
      >
        <div className="w-full overflow-y-auto h-[90vh]">
          <div className="max-w-[1140px] qhd:max-w-[60%]   mx-auto  flex flex-col  items-center gap-2 justify-center py-4">
            <div className="">
              <p className="text-primary_light text-center  ">
                {datadetail?.category}
              </p>
            </div>
            <div className="text-justify max-w-[1140px] mx-auto ">
              <p className="text-primary text-4xl text-center">
                {datadetail?.title}
              </p>
            </div>
            <div className="w-[20px] bg-primary h-[2px]"></div>
            <div className="flex gap-4 justify-center items-center">
              <p className="text-primary text-sm">
                Create by : {datadetail?.creator}
              </p>
            </div>
          </div>

          {/* image part */}
          <div className="max-w-[1140px] qhd:max-w-[60%] mx-auto ">
            <div className="pt-[70px]  gap-4 md:max-lg:w-[90%]">
              <div className=" pb-[100px]">
                <img
                  className="w-full h-[500px] object-cover md:rounded-xl pv:max-sm:object-fill  pv:max-sm:h-full "
                  src={datadetail?.thumbnail}
                  alt=""
                ></img>
              </div>
            </div>
            <div className=" w-[80%]  mx-auto text-[1.125rem] text-primary_light whitespace-pre-line text-justify">
              <div className="ProseMirror">{parse(datadetail?.content)}</div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ManageBlogs;
